var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"footer"}},[_c('div',{staticClass:"list"},_vm._l((_vm.navigation),function(item){return _c('router-link',{key:item.name,staticClass:"item",class:[item.name, { selected: _vm.route && _vm.route.includes(item.name) }],attrs:{"to":item.route}},[_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.$t(item.title)))])])}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }